// src/appoinmentApp/doctor/AddBlog.js
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { createBlog, resetCreateBlog } from 'src/actions/blogActions';
const AddBlog = ({ createBlog, resetCreateBlog, blogState }) => {
  const [blogData, setBlogData] = useState({
    title: '',
    content: '',
    image: null
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const { loading, error, success } = blogState;

  useEffect(() => {
    if (success) {
      setSubmitted(true);
      // Reset form after successful submission
      setBlogData({
        title: '',
        content: '',
        image: null
      });
      setImagePreview(null);
      
      // Reset success state after 3 seconds
      const timer = setTimeout(() => {
        resetCreateBlog();
        setSubmitted(false);
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [success, resetCreateBlog]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBlogData({
      ...blogData,
      [name]: value
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBlogData({
        ...blogData,
        image: file
      });
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create FormData for file upload
    const formData = new FormData();
    formData.append('title', blogData.title);
    formData.append('content', blogData.content);
    formData.append('status',"created")
    if (blogData.image) {
      formData.append('image', blogData.image);
    }
    
    // Add hospital ID from localStorage
    const hospitalID = localStorage.getItem('hospitalCode');
    if (hospitalID) {
      formData.append('hospitalID', hospitalID);
    }
    
    // Dispatch the createBlog action
    createBlog(formData);
  };

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add New Blog Post</h4>
              </div>
              <div className="card-body">
                {submitted && (
                  <div className="alert alert-success" role="alert">
                    Blog published successfully!
                  </div>
                )}
                
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Blog Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={blogData.title}
                      onChange={handleChange}
                      placeholder="Enter blog title"
                      required
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label>Blog Content</label>
                    <textarea
                      className="form-control"
                      name="content"
                      rows="10"
                      value={blogData.content}
                      onChange={handleChange}
                      placeholder="Write your blog content here..."
                      required
                      disabled={loading}
                    ></textarea>
                  </div>

                  <div className="form-group">
                    <label>Featured Image</label>
                    <input
                      type="file"
                      className="form-control-file"
                      accept="image/*"
                      onChange={handleImageChange}
                      disabled={loading}
                    />
                    <small className="form-text text-muted">
                      Recommended size: 800x450 pixels
                    </small>
                  </div>

                  {imagePreview && (
                    <div className="form-group">
                      <label>Image Preview</label>
                      <div className="mt-2">
                        <img 
                          src={imagePreview} 
                          alt="Preview" 
                          className="img-fluid"
                          style={{maxHeight: '200px'}}
                        />
                      </div>
                    </div>
                  )}

                  <button 
                    type="submit" 
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? 'Publishing...' : 'Publish Blog'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  blogState: state.blogReducer
});

export default connect(mapStateToProps, { createBlog, resetCreateBlog })(AddBlog);